import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Checkbox } from "antd";

const ModalFormComponent = ({ visible, loading, data, menus, onCancel, onCreate, handleParentMenu, parentMenu, form }) => {
  const { getFieldDecorator, setFieldsValue } = form;

  const Option = Select.Option;

  useEffect(() => {
    setFieldsValue({
      text: data?.text,
      slug: data?.slug,
      parent: data?.parent,
      onNewWindow: data?.newWindow
    });
  }, [data]);

  return (
    <Modal
      visible={visible}
      title="Edit Menu"
      okText="Submit"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={onCreate}
    >
      <Form onSubmit={(e) => this.handleSubmit(e)} layout="vertical">

        <Form.Item label="Text">
          {getFieldDecorator("text", {
            rules: [{
              required: true,
              message: 'Required!'
            }]
          })(<Input />)}
        </Form.Item>

        <Form.Item label="Slug">
          {getFieldDecorator('slug', {
            rules: [{
              required: true,
              message: 'Required!'
            }]
          })(
            <Input type="textarea" />
          )}
        </Form.Item>

        <Form.Item
          label="Parent Menu"
        >
          {getFieldDecorator('parent', {
          })(
            <Select
              value={parentMenu}
              placeholder="Parent Menu"
              optionFilterProp="children"
              onChange={handleParentMenu}
              showSearch
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              <Option value={true}>{"No Parent"}</Option>
              {menus.map((item, i) => {
                return (
                  <Option key={i} value={item._id}>
                    {item.name}
                  </Option>
                );
              })}
            </Select>
          )}
        </Form.Item>

        <Form.Item label="Open In New Window">
          {getFieldDecorator('newWindow')(
            <Checkbox></Checkbox>
          )}
        </Form.Item>

      </Form>
    </Modal>
  );
};

const ModalForm = Form.create({ name: "modal_form" })(ModalFormComponent);

export default ModalForm;